import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: '404',
    notFound: 'Page not found',
  },
};
